import { TipoEvaluacion } from './tipo-evaluacion.model';
import { EstructuraJerarquica } from './estructura-jerarquica.model';
import { Usuario } from './usuario.model';
import { Evaluacion } from './evaluacion.model';

export class NodoEstructuraJerarquica {

    id: number;
    nombre: string;
    descripcion: string[];
    padre: EstructuraJerarquica;
    hijos: NodoEstructuraJerarquica[];
    usuarios: Usuario[];
    evaluaciones: Evaluacion[];
    valor: NodoEstructuraJerarquica;
    level: number;
    expandable: boolean;
    editable: boolean;
    estructuraNombre: string;
    enabled: boolean;

    /**
     * Constructor
     *
     * @param nodo
     */
    constructor(nodo)
    {
        {
            this.id = nodo.id || null;
            this.nombre = nodo.nombre || '';
            this.descripcion = nodo.descripcion || '';
            this.padre = nodo.padre || null;
            this.hijos = nodo.hijos || [];
            this.usuarios = nodo.usuarios || [];
            this.evaluaciones = nodo.evaluaciones || [];
            this.estructuraNombre = nodo.estructuraNombre || "";
            this.enabled = nodo.enabled || true;
        }
    }
}

export function getUsuariosNodo(estructura:NodoEstructuraJerarquica):Usuario[]{

      var usuarios = [];
      var usuariosId = [];

      estructura.usuarios.forEach(usuario => {
        usuarios.push(usuario);
        usuariosId.push(usuario.id);
      });

      estructura.hijos.forEach(element => {

        getUsuariosNodo(element).forEach(usuario => {

          if(usuariosId.indexOf(usuario.id)==-1){
            usuarios.push(usuario);
            usuariosId.push(usuario.id);
          }

        });

      });


      return usuarios;

    }
